import {
    ANALYSIS_CHALLENGES_REQUESTED,
    ANALYSIS_CHALLENGES_SUCCEEDED,
    ANALYSIS_CHALLENGES_FAILED,
    ANALYSIS_RESEARCHERS_REQUESTED,
    ANALYSIS_RESEARCHERS_SUCCEEDED,
    ANALYSIS_RESEARCHERS_FAILED,
    ANALYSIS_SEGMENTS_REQUESTED,
    ANALYSIS_SEGMENTS_SUCCEEDED,
    ANALYSIS_SEGMENTS_FAILED,
    SEGMENTS_REPORT_REQUESTED,
    SEGMENTS_REPORT_SUCCEEDED,
    SEGMENTS_REPORT_FAILED,
    TOP_OBJECTS_REQUESTED,
    TOP_OBJECTS_SUCCEEDED,
    TOP_OBJECTS_FAILED,
    TOP_MATERIALS_REQUESTED,
    TOP_MATERIALS_SUCCEEDED,
    TOP_MATERIALS_FAILED,
    TOP_BRANDS_REQUESTED,
    TOP_BRANDS_SUCCEEDED,
    TOP_BRANDS_FAILED,
    OBJECTS_TAGS_REQUESTED,
    OBJECTS_TAGS_SUCCEEDED,
    OBJECTS_TAGS_FAILED,
    BRANDS_TAGS_REQUESTED,
    BRANDS_TAGS_SUCCEEDED,
    BRANDS_TAGS_FAILED,
    MATERIALS_TAGS_REQUESTED,
    MATERIALS_TAGS_SUCCEEDED,
    MATERIALS_TAGS_FAILED,
    HEATMAP_LITTERS_FAILED,
    HEATMAP_LITTERS_REQUESTED,
    HEATMAP_LITTERS_SUCCEEDED,
    SEGMENTS_INDEX_REQUESTED,
    SEGMENTS_INDEX_SUCCEEDED,
    SEGMENTS_INDEX_FAILED,
} from './constants';

const initialState = {
    // initialize empty array for challenges
    challenges: [],
    // initialize boolean to represent Challenges loading state
    isChallengesLoading: false,
    // error in challenge request
    challengeError: null,
    // initialize empty array for researchers
    researchers: [],
    // initialize boolean to represent researchers loading state
    isResearchersLoading: false,
    // error in researchers request
    researchersError: null,
    // initialize empty array for segments
    segments: [],
    // initialize boolean to represent segments loading state
    isSegmentsLoading: false,
    // error in segment request
    segmentsError: null,
    // selected challenges inside multi-select field
    selectedChallenges: [],
    // selected researchers inside multi-select field
    selectedResearchers: [],
    // selected segments inside multi-select field
    selectedSegments: [],
    // selected segments inside multi-select field for comparison, group 2
    selectedSegmentsCompare: [],
    // indicates whether the report is comparison or not
    isComparisonActive: false,
    // indicates whether the request for report has been initiated or not
    isReportRequested: false,
    // indicates whether the request for report has been initiated or not
    isReportFinished: true,
    // top materials for summary graph
    topMaterials: [],
    // top objects for summary graph
    topObjects: [],
    // top brands for summary graph
    topBrands: [],
    // indicates loading state of top object graph
    isTopObjectLoading: false,
    // indicates loading state of top material graph
    isTopMaterialLoading: false,
    // indicates loading state of top brands graph
    isTopBrandLoading: false,
    // all objects, with their counts
    objectsTags: [],
    isObjectsTagsLoading: false,
    // all material, with their counts
    materialsTags: [],
    isMaterialsTagsLoading: false,
    // all brand, with their counts
    brandsTags: [],
    isBrandsTagsLoading: false,

    heatmapLitters: [],
    isHeatmapLoading: false,

    segmentsIndex: [],
    isSegmentsIndexLoading: false,

    /* ==== Segment group 2 / compare group states ==== begin */

    topObjectsCompare: [],
    topMaterialsCompare: [],
    topBrandsCompare: [],

    // all objects, with their counts
    objectsTagsCompare: [],
    // all material, with their counts
    materialsTagsCompare: [],
    // all brand, with their counts
    brandsTagsCompare: [],

    /* ==== Segment group 2 / compare group states ==== ends */

    // global error state, contains the most recent error
    error: null,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case ANALYSIS_CHALLENGES_REQUESTED: {
            const { challenges } = action;
            return {
                ...state,
                challenges,
                isChallengesLoading: true,
            };
        }
        case ANALYSIS_RESEARCHERS_REQUESTED: {
            const { selectedChallenges } = action;
            return {
                ...state,
                selectedChallenges,
                isResearchersLoading: true,
            };
        }
        case ANALYSIS_SEGMENTS_REQUESTED: {
            const { selectedChallenges, selectedResearchers } = action;
            return {
                ...state,
                selectedChallenges,
                selectedResearchers,
                isSegmentsLoading: true,
            };
        }
        case ANALYSIS_CHALLENGES_SUCCEEDED: {
            const { challenges } = action;
            return {
                ...state,
                challenges,
                isChallengesLoading: false,
            };
        }
        case ANALYSIS_RESEARCHERS_SUCCEEDED: {
            const { researchers } = action;
            return {
                ...state,
                researchers,
                isResearchersLoading: false,
            };
        }
        case ANALYSIS_SEGMENTS_SUCCEEDED: {
            const { segments } = action;
            return {
                ...state,
                segments,
                isSegmentsLoading: false,
            };
        }
        case ANALYSIS_CHALLENGES_FAILED: {
            const { error } = action;
            return {
                ...state,
                challengeError: error,
                error,
                isChallengesLoading: false,
            };
        }
        case ANALYSIS_RESEARCHERS_FAILED: {
            const { error } = action;
            return {
                ...state,
                researchersError: error,
                error,
                isResearchersLoading: false,
            };
        }
        case ANALYSIS_SEGMENTS_FAILED: {
            const { error } = action;
            return {
                ...state,
                segmentsError: error,
                error,
                isSegmentsLoading: false,
            };
        }
        case SEGMENTS_REPORT_REQUESTED: {
            const {
                selectedSegments,
                selectedChallenges,
                selectedResearchers,
                selectedSegmentsCompare,
                isComparisonActive,
            } = action;
            return {
                ...state,
                isReportRequested: true,
                selectedSegments,
                selectedChallenges,
                selectedResearchers,
                selectedSegmentsCompare,
                isComparisonActive:
                    isComparisonActive && !!selectedSegmentsCompare.length,
            };
        }
        case SEGMENTS_REPORT_SUCCEEDED: {
            const { selectedSegments } = action;
            return {
                ...state,
                isReportFinished: true,
                isReportRequested: false,
                selectedSegments,
            };
        }
        case SEGMENTS_REPORT_FAILED: {
            const { error } = action;
            return {
                ...state,
                isReportRequested: false,
                isReportFinished: true,
                error,
            };
        }
        case TOP_OBJECTS_REQUESTED: {
            return {
                ...state,
                isTopObjectLoading: true,
            };
        }
        case TOP_OBJECTS_SUCCEEDED: {
            const { topObjects, topObjectsCompare } = action;
            return {
                ...state,
                isTopObjectLoading: false,
                topObjects,
                topObjectsCompare,
            };
        }
        case TOP_OBJECTS_FAILED: {
            const { error } = action;
            return {
                ...state,
                isTopObjectLoading: false,
                error,
            };
        }
        case TOP_MATERIALS_REQUESTED: {
            return {
                ...state,
                isTopMaterialsLoading: true,
            };
        }
        case TOP_MATERIALS_SUCCEEDED: {
            const { topMaterials, topMaterialsCompare } = action;
            return {
                ...state,
                topMaterials,
                topMaterialsCompare,
                isTopMaterialsLoading: false,
            };
        }
        case TOP_MATERIALS_FAILED: {
            const { error } = action;
            return {
                ...state,
                isTopMaterialsLoading: false,
                error,
            };
        }
        case TOP_BRANDS_REQUESTED: {
            return {
                ...state,
                isTopBrandsLoading: true,
            };
        }
        case TOP_BRANDS_SUCCEEDED: {
            const { topBrands, topBrandsCompare } = action;
            return {
                ...state,
                topBrands,
                isTopBrandsLoading: false,
                topBrandsCompare,
            };
        }
        case TOP_BRANDS_FAILED: {
            const { error } = action;
            return {
                ...state,
                isTopBrandsLoading: false,
                error,
            };
        }
        case OBJECTS_TAGS_REQUESTED: {
            return {
                ...state,
                isObjectsTagsLoading: true,
            };
        }
        case OBJECTS_TAGS_SUCCEEDED: {
            const { objectsTags, objectsTagsCompare } = action;
            return {
                ...state,
                isObjectsTagsLoading: false,
                objectsTags,
                objectsTagsCompare,
            };
        }
        case OBJECTS_TAGS_FAILED: {
            const { error } = action;
            return {
                ...state,
                isObjectsTagsLoading: false,
                error,
            };
        }
        case BRANDS_TAGS_REQUESTED: {
            return {
                ...state,
                isBrandsTagsLoading: true,
            };
        }
        case BRANDS_TAGS_SUCCEEDED: {
            const { brandsTags, brandsTagsCompare } = action;
            return {
                ...state,
                isBrandsTagsLoading: false,
                brandsTags,
                brandsTagsCompare,
            };
        }
        case BRANDS_TAGS_FAILED: {
            const { error } = action;
            return {
                ...state,
                isBrandsTagsLoading: false,
                error,
            };
        }
        case MATERIALS_TAGS_REQUESTED: {
            return {
                ...state,
                isMaterialsTagsLoading: true,
            };
        }
        case MATERIALS_TAGS_SUCCEEDED: {
            const { materialsTags, materialsTagsCompare } = action;
            return {
                ...state,
                isMaterialsTagsLoading: false,
                materialsTags,
                materialsTagsCompare,
            };
        }
        case MATERIALS_TAGS_FAILED: {
            const { error } = action;
            return {
                ...state,
                isMaterialsTagsLoading: false,
                error,
            };
        }
        case HEATMAP_LITTERS_REQUESTED: {
            const { startDate } = action;
            return {
                ...state,
                heatmapStartDate: startDate,
                isHeatmapLoading: true,
            };
        }
        case HEATMAP_LITTERS_SUCCEEDED: {
            const { heatmapLitters } = action;
            return {
                ...state,
                heatmapLitters,
                isHeatmapLoading: false,
            };
        }
        case HEATMAP_LITTERS_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                isHeatmapLoading: false,
            };
        }
        case SEGMENTS_INDEX_REQUESTED: {
            return {
                ...state,
                isSegmentsIndexLoading: true,
            };
        }
        case SEGMENTS_INDEX_SUCCEEDED: {
            const { segmentsIndex } = action;
            return {
                ...state,
                isSegmentsIndexLoading: false,
                segmentsIndex,
            };
        }
        case SEGMENTS_INDEX_FAILED: {
            const { error } = action;
            return {
                ...state,
                isSegmentsIndexLoading: false,
                error,
            };
        }

        default:
            return state;
    }
}
